import landscapeSrc from "./landscape.svg";
import portraitSrc from "./portrait.svg";

const nuyouPlaceholders = {
  landscape: {
    src: landscapeSrc,
    srcWidth: 1080,
    srcHeight: 720,
    alt: "",
  },
  portrait: {
    src: portraitSrc,
    srcWidth: 768,
    // For 9:16 aspect ratio; Change to 1024 for 4:5 aspect ratio
    srcHeight: 1365,
    alt: "",
  },
  square: {
    src: portraitSrc,
    srcWidth: 315,
    srcHeight: 315,
    alt: "",
  },
  wide: {
    src: landscapeSrc,
    srcWidth: 1000,
    srcHeight: 500,
    alt: "",
  },
};

export default nuyouPlaceholders;
